import {
  SAP_AUDIT_STATS_LOADING,
  SAP_AUDIT_STATS_SUCCESS,
  SAP_AUDIT_STATS_ERROR,
  SAP_AUDIT_LOGS_LOADING,
  SAP_AUDIT_LOGS_SUCCESS,
  SAP_AUDIT_LOGS_ERROR,
  SAP_AUDIT_DETAIL_LOADING,
  SAP_AUDIT_DETAIL_SUCCESS,
  SAP_AUDIT_DETAIL_ERROR,
  SAP_AUDIT_DETAIL_CLEAR,
  SAP_AUDIT_SET_FILTERS,
  SAP_AUDIT_RESET_FILTERS,
  SAP_AUDIT_SET_PAGE,
  SAP_AUDIT_SET_PAGE_SIZE,
} from '../../actions/types';

const defaultFilters = {
  dateFrom: null,
  dateTo: null,
  direction: null,
  flowType: null,
  status: null,
  search: '',
};

const initialState = {
  stats: null,
  statsLoading: false,

  logs: [],
  total: 0,
  logsLoading: false,

  page: 1,
  pageSize: 50,

  filters: { ...defaultFilters },

  detail: null,
  detailLoading: false,

  error: null,
};

const sapAuditReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAP_AUDIT_STATS_LOADING:
      return { ...state, statsLoading: action.payload };

    case SAP_AUDIT_STATS_SUCCESS:
      return { ...state, stats: action.payload, error: null };

    case SAP_AUDIT_STATS_ERROR:
      return { ...state, error: action.payload };

    case SAP_AUDIT_LOGS_LOADING:
      return { ...state, logsLoading: action.payload };

    case SAP_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload.logs,
        total: action.payload.total,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        error: null,
      };

    case SAP_AUDIT_LOGS_ERROR:
      return { ...state, error: action.payload };

    case SAP_AUDIT_DETAIL_LOADING:
      return { ...state, detailLoading: action.payload };

    case SAP_AUDIT_DETAIL_SUCCESS:
      return { ...state, detail: action.payload, error: null };

    case SAP_AUDIT_DETAIL_ERROR:
      return { ...state, error: action.payload };

    case SAP_AUDIT_DETAIL_CLEAR:
      return { ...state, detail: null };

    case SAP_AUDIT_SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case SAP_AUDIT_RESET_FILTERS:
      return { ...state, filters: { ...defaultFilters }, page: 1 };

    case SAP_AUDIT_SET_PAGE:
      return { ...state, page: action.payload };

    case SAP_AUDIT_SET_PAGE_SIZE:
      return { ...state, pageSize: action.payload };

    default:
      return state;
  }
};

export default sapAuditReducer;
